import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const siteLink = useSelector((state) => state.navigation.siteLink);
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    return <NavigationItem siteLink={siteLink} links={contentLinks} />;
};

export default Navigation;
